import React, { useState } from 'react';
import './deleteAccount.css'
import Header from '../../../layout/DefaultLayout/Header';

const DeleteAccount = () => {
    const [mobileNumber, setMobileNumber] = useState('');
    const [userType, setUserType] = useState('Customer');
    const [message, setMessage] = useState('');

    const handleMobileNumberChange = (e) => {
        setMobileNumber(e.target.value);
    };

    const handleUserTypeChange = (e) => {
        setUserType(e.target.value);
    };

    const handleSubmit = () => {
        // Perform form submission logic here, such as sending data to a server
        console.log('Mobile Number:', mobileNumber);
        console.log('User Type:', userType);
        // You can reset the form fields here if needed
        setMobileNumber('');
        setUserType('Customer');
        setMessage('We will review your details & process your request in a week!')
    };

    return (
        <>
            <Header />
            <div className='formContainer'>
                <div className='formHeader'>Delete Account</div>
                <div className='mobileCont'>
                    <label className='label' htmlFor="mobileNumber">Mobile Number:</label>
                    <input
                        type="text"
                        id="mobileNumber"
                        value={mobileNumber}
                        onChange={handleMobileNumberChange}
                        className='inputField'
                        placeholder='Mobile number'
                    />
                </div>
                <div className='userTypeCont'>
                    <label className='label' htmlFor="userType">User Type:</label>
                    <select className='inputField dropdown' id="userType" value={userType} onChange={handleUserTypeChange}>
                        <option value="Customer">Customer</option>
                        <option value="Provider">Provider</option>
                    </select>
                </div>
                <button className='submitButton' type="button" onClick={() => handleSubmit()}>Delete Account</button>
                {
                    message &&
                    <div className='message'>{message}</div>
                }
            </div>
        </>
    );
};

export default DeleteAccount;
